import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeaderSection } from './components/HeaderSection';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { UnifiedServicesSection } from './components/UnifiedServicesSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from './components/FooterSection';
import { WhatsAppButton } from './components/WhatsAppButton';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { Disclaimer } from './pages/Disclaimer';
import { GetQuote } from './pages/GetQuote';
const HomePage = () => {
  return <>
      <HeroSection data-id="element-0" />
      <AboutSection data-id="element-1" />
      <UnifiedServicesSection data-id="element-2" />
      <ContactSection data-id="element-3" />
    </>;
};
export function App() {
  return <BrowserRouter data-id="element-4">
      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-5">
        <HeaderSection data-id="element-6" />
        <Routes data-id="element-7">
          <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
          <Route path="/get-quote" element={<GetQuote data-id="element-11" />} data-id="element-10" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-13" />} data-id="element-12" />
          <Route path="/terms-of-service" element={<TermsOfService data-id="element-15" />} data-id="element-14" />
          <Route path="/disclaimer" element={<Disclaimer data-id="element-17" />} data-id="element-16" />
        </Routes>
        <FooterSection data-id="element-18" />
        <WhatsAppButton data-id="element-19" />
      </div>
    </BrowserRouter>;
}